import { UseEvent } from "./index";

export default function UseRegister() {
  const event = UseEvent();
  const open = (params = {}) => {
    event.emit("lb-event", {
      type: "Register",
      ...params,
    });
  };

  return { open };
}
